import { render } from "./sNovymGodomView.vue?vue&type=template&id=7283305a"
import script from "./sNovymGodomView.vue?vue&type=script&lang=js"
export * from "./sNovymGodomView.vue?vue&type=script&lang=js"

import "./sNovymGodomView.vue?vue&type=style&index=0&id=7283305a&lang=css"

import exportComponent from "C:\\work\\game\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__